export const VIEW_MODE = {
  HISTORICAL: "HISTORICAL",
  MONTHLY: "MONTHLY",
  QUARTERLY: "QUARTERLY",
  ANNUAL: "ANNUAL",
};

export const HISTORICAL_RANGE = {
  LAST_MONTH: "LAST_MONTH",
  CURRENT_QUARTER: "CURRENT_QUARTER",
  CURRENT_YEAR: "CURRENT_YEAR",
  LAST_2_YEARS: "LAST_2_YEARS",
  FULL_HISTORY: "FULL_HISTORY",
};

export const ACCESS_SOURCE = {
  FREE: "FREE",
  MONTHLY_SUBSCRIPTION: "MONTHLY_SUBSCRIPTION",
};

export const PLAN_FAMILY = {
  FREE: "FREE",
  MONTHLY_SUBSCRIPTION: "MONTHLY_SUBSCRIPTION",
};

export const HISTORICAL_RANGE_LABEL = {
  LAST_MONTH: "Last month",
  CURRENT_QUARTER: "Current quarter",
  CURRENT_YEAR: "Current year",
  LAST_2_YEARS: "Last 2 years",
  FULL_HISTORY: "Full history",
};

export const REPORT_TYPE_LABEL = {
  benchmark: "Shop Summary",
  meta: "Meta Ads Report",
  google_search_console: "Google Search Console",
  google_merchant_center: "Google Merchant Center",
  revenue_reality: "Revenue Reality Report",
  market: "Shop Market Analysis",
  target_audience: "Target Audience",
  competitor: "Shop Competitor Analysis",
  yearlyContent: "Monthly Events Calendar",
};
